import React from 'react';
import styles from './DeviceCard.module.css';
import { Unit, Device, RealTimeDeviceData, ValveState, Alert, User } from 'model';
import TelemetryCard from './TelemetryCard';
import DeviceListCard from './DeviceListCard';
import { ConfirmationPopupFunction } from 'effects';

type DeviceCardProps = {
  currentUnit?:                   Unit,
  currentDevice?:                 Device,
  hasMultipleDevices:             boolean,
  currentDeviceRealtime?:         RealTimeDeviceData,
  loggedUser?:                    User,
  updatedTelemetryText:           string,
  realtimeMap:                    { [macAddress: string]: RealTimeDeviceData },
  setCurrentDevice:               (macAddress: string) => void,
  isLoadingUnit:                  boolean,
  changeValveState:               (deviceId: string, target: ValveState) => void,
  deleteDevice:                   (deviceId: string) => void,
  updateDevice:                   (deviceId: string, device: Partial<Device>) => void,
  openConfirmationPopup:          ConfirmationPopupFunction,
  openTextConfirmationPopup:      ConfirmationPopupFunction,
  handleRenameDevicePopup:        ConfirmationPopupFunction,
  openSetThresholds:              () => void,
  openAutoShutoff:                 () => void,
  openAlarmSettings:              () => void,
  pendingAlertsForCurrentDevice:  Alert[],
  resolveAlert:                   (alert: Alert, snoozeSeconds?: number) => void,
  runHealthTest:                  (deviceId: string) => void,
  openDeveloperMenu:              () => void,
}

export const DeviceCard: React.FC<DeviceCardProps> =  React.memo(({
  currentUnit,
  currentDevice,
  hasMultipleDevices,
  currentDeviceRealtime,
  loggedUser,
  updatedTelemetryText,
  realtimeMap,
  setCurrentDevice,
  isLoadingUnit,
  changeValveState,
  deleteDevice,
  updateDevice,
  openConfirmationPopup,
  openTextConfirmationPopup,
  handleRenameDevicePopup,
  openSetThresholds,
  openAutoShutoff,
  openAlarmSettings,
  pendingAlertsForCurrentDevice,
  resolveAlert,
  runHealthTest,
  openDeveloperMenu,
}) => {
  return (
    <div className={styles.root}>
      <TelemetryCard
        currentDevice                 = {currentDevice}
        currentUnit                   = {currentUnit}
        realtime                      = {currentDeviceRealtime}
        loggedUser                    = {loggedUser}
        updatedTelemetryText          = {updatedTelemetryText}
        isLoadingUnit                 = {isLoadingUnit}
        changeValveState              = {changeValveState}
        deleteDevice                  = {deleteDevice}
        updateDevice                  = {updateDevice}
        openConfirmationPopup         = {openConfirmationPopup}
        openTextConfirmationPopup     = {openTextConfirmationPopup}
        handleRenameDevicePopup       = {handleRenameDevicePopup}
        openSetThresholds             = {openSetThresholds}
        openAutoShutoff                = {openAutoShutoff}
        openAlarmSettings             = {openAlarmSettings}
        pendingAlertsForCurrentDevice = {pendingAlertsForCurrentDevice}
        resolveAlert                  = {resolveAlert}
        runHealthTest                 = {runHealthTest}
        openDeveloperMenu             = {openDeveloperMenu}
      />
      { hasMultipleDevices &&
        <DeviceListCard
          currentDevice     = {currentDevice}
          realtimeMap       = {realtimeMap}
          currentUnit       = {currentUnit}
          setCurrentDevice  = {setCurrentDevice}
        />
      }
    </div>
  );
});

export default DeviceCard;
